module.exports = __webpack_public_path__ + "assets/img/excel.aa055787.svg";